'use client';

import { filtersListAtom } from '@core/Atoms/Plp/FiltersListAtom';
import { DEFAULT_SORTING, SORT_KEY, SORT_OPTIONS_FR, SORT_OPTIONS_UK } from '@core/Constants/Sort';
import { Locale } from '@core/Entities/Locale/Locale.entity';
import { getFilterFromArray } from '@core/Utils/SearchFilters/GetFilterFromArray';
import { Sort } from '@gds/Icons/Paths/Sort';
import { useAtomValue, useSetAtom } from 'jotai';

import { sortDrawerOpenAtom } from 'Atoms/App/Plp/SortDrawerOpenAtom';

import { SortMessages } from '../Filters/Components/Sort/Sort.messages';

import styles from './QuickFilters.module.css';

export const QuickFiltersSort = ({
  locale,
  sortMessages,
}: {
  locale: Locale;
  sortMessages: SortMessages;
}) => {
  const openSortDrawer = useSetAtom(sortDrawerOpenAtom);
  const filtersList = useAtomValue(filtersListAtom);

  const sortFilter = getFilterFromArray(SORT_KEY, filtersList);

  const sortOptions = (locale === 'fr' ? SORT_OPTIONS_FR : SORT_OPTIONS_UK).map(option => ({
    label: sortMessages[option as keyof SortMessages],
    value: option,
  }));

  const selectedSortValue = sortFilter
    ? sortOptions.find(option => option.value === sortFilter?.value)
    : sortOptions.find(option => option.value === DEFAULT_SORTING[locale]);

  return (
    <div className={styles.sort}>
      <button className="typography-subheading-3" onClick={() => openSortDrawer(true)}>
        {selectedSortValue?.label}
        <Sort />
      </button>
    </div>
  );
};
